
import { Record, Union } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Types.js";
import { record_type, lambda_type, unit_type, union_type, class_type, list_type, anonRecord_type, bool_type, string_type, option_type, int32_type } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { Helper_receiverTypeNameTranslation, Requests_UserDto_$reflection, ReceiverTypeName, Receiver_$reflection } from "../../../Shared/User.js";
import { Storage_$reflection } from "../../../Shared/Storage.js";
import { FormState__getValidation, UserId as UserId_1, FormState__startLoading, AssignToolWithQuantityWithNotificationDto, ToolId, FormState__setValidationResponse_5219762A, RequestedValue$1, FormState_get_empty, AssignToolWithQuantityWithoutNotificationDto, RequestedValue$1_$reflection, FormState_$reflection, AssignToolWithQuantityWithoutNotificationDto_$reflection, ClientApiResponse$1_$reflection } from "../../../Shared/Shared.js";
import { ImageUpload, DnDFormImage, DnDFormImage_$reflection } from "../../../Widgets/Image/ImageUploadDnD.js";
import { FileUploadResponse_$reflection } from "../../../Shared/File.js";
import { ToolWithQuantityDetailDto_$reflection } from "../../../Shared/Tool.js";
import { sortBy, toArray, isEmpty, sum, tryFind, map, contains, append, max, filter, tryPick, sumBy, choose, find, ofArray, singleton, empty } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Cmd_ofEffect, Cmd_none, Cmd_batch } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_OfPromise_either } from "../../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { fetchWithDecoder, addPrefix } from "../../../CommunicationV2.js";
import { Types_RequestProperties } from "../../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { ValidationOnGetRequest } from "../../../ErrorHandling.js";
import { join, concat } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { Async_fetchWithDecoder, addPrefix as addPrefix_1, fetchWithDecoder as fetchWithDecoder_1 } from "../../../Communication.js";
import { Cmd_successToast, Cmd_errorToast } from "../../../Components/Toast.js";
import { doRangesOverlap, unwrapStorageId } from "../../../Shared/Helper.js";
import { safeHash, createObj, Exception, stringHash, comparePrimitives, equals } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Util.js";
import { assignCmd, assignWithNotificationCmd } from "../../../Requests/ToolWithQuantity.js";
import { parse } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Guid.js";
import { uploadImage } from "../../../Requests/Files.js";
import { createElement } from "react";
import React from "react";
import { useTranslation } from "react-i18next";
import { useFeliz_React__React_useDeferred_Static_Z241A641 } from "../../../fable_modules/Feliz.UseDeferred.2.0.0/UseDeferred.fs.js";
import { unwrapUserId } from "../../../Shared/Helper.js";
import { HttpMethod } from "../../../fable_modules/Fable.SimpleHttp.3.6.0/Types.fs.js";
import { singleton as singleton_1 } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/AsyncBuilder.js";
import { spinner } from "../../../SharedComponents/Spinners.js";
import { unwrap, map as map_1 } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { addDays, today } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Date.js";
import { ErrorAlert, InformationAlert, WarningAlert } from "../../../Components/Alert.js";
import { reactApi, reactElement } from "../../../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { singleton as singleton_2, empty as empty_1, append as append_1, delay, toList } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq.js";
import { GroupedSelect, Select } from "../../../Components/Select.js";
import { List_groupBy } from "../../../fable_modules/fable-library-js.5.0.0-rc.2/Seq2.js";
import { TextArea } from "../../../Components/TextArea.js";
import { NumberInput } from "../../../Components/Input.js";
import { numberInputIntMaxValue } from "../../../Common.js";
import { Checkbox } from "../../../Components/Checkbox.js";
import { TextValue } from "../../../Components/Text.js";
import { React_useElmish_Z6C327F2E } from "../../../fable_modules/Feliz.UseElmish.2.5.0/UseElmish.fs.js";
import { ProgramModule_mkProgram } from "../../../fable_modules/Fable.Elmish.5.0.2/program.fs.js";
import { Dialog } from "../../../Components/Dialog.js";
import { Skeleton } from "../../../Components/Skeleton.js";
import { TextButton } from "../../../Components/Button.js";

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["SetQuantity", "SetComment", "SetWithNotification", "SetWithSignature", "SetSelectedUser", "SetSelectedStorage", "AssignedToolResponse", "OnAssignTool", "ReceiversFetched", "StoragesFetched", "FetchError", "SetSelectedSenderFiles", "SenderImageUploaded"];
    }
}

function Msg_$reflection() {
    return union_type("Tools.AssignToolWithQuantityDialog.Msg", [], Msg, () => [[["Item", option_type(int32_type)]], [["Item", string_type]], [["Item", bool_type]], [["Item", bool_type]], [["Item", option_type(anonRecord_type(["label", string_type], ["value", Receiver_$reflection()]))]], [["Item", option_type(anonRecord_type(["label", string_type], ["value", Storage_$reflection()]))]], [["Item", ClientApiResponse$1_$reflection(string_type)]], [], [["Item", list_type(Receiver_$reflection())]], [["Item", list_type(Storage_$reflection())]], [["Item", class_type("System.Exception")]], [["Item", list_type(DnDFormImage_$reflection())]], [["Item", FileUploadResponse_$reflection()]]]);
}

class State extends Record {
    constructor(Quantity, ToolWithQuantity, Dto, FormState, SuccessCallback, OnClose, SelectedUser, SelectedStorage, IsStockInvalid, WithNotification, WithSignature, Receivers, Storages, SenderImageFiles, ImageUploading) {
        super();
        this.Quantity = Quantity;
        this.ToolWithQuantity = ToolWithQuantity;
        this.Dto = Dto;
        this.FormState = FormState;
        this.SuccessCallback = SuccessCallback;
        this.OnClose = OnClose;
        this.SelectedUser = SelectedUser;
        this.SelectedStorage = SelectedStorage;
        this.IsStockInvalid = IsStockInvalid;
        this.WithNotification = WithNotification;
        this.WithSignature = WithSignature;
        this.Receivers = Receivers;
        this.Storages = Storages;
        this.SenderImageFiles = SenderImageFiles;
        this.ImageUploading = ImageUploading;
    }
}

function State_$reflection() {
    return record_type("Tools.AssignToolWithQuantityDialog.State", [], State, () => [["Quantity", option_type(int32_type)], ["ToolWithQuantity", ToolWithQuantityDetailDto_$reflection()], ["Dto", AssignToolWithQuantityWithoutNotificationDto_$reflection()], ["FormState", FormState_$reflection()], ["SuccessCallback", lambda_type(unit_type, unit_type)], ["OnClose", lambda_type(unit_type, unit_type)], ["SelectedUser", option_type(anonRecord_type(["label", string_type], ["value", Receiver_$reflection()]))], ["SelectedStorage", option_type(anonRecord_type(["label", string_type], ["value", Storage_$reflection()]))], ["IsStockInvalid", option_type(int32_type)], ["WithNotification", bool_type], ["WithSignature", bool_type], ["Receivers", RequestedValue$1_$reflection(list_type(Receiver_$reflection()))], ["Storages", RequestedValue$1_$reflection(list_type(Storage_$reflection()))], ["SenderImageFiles", list_type(DnDFormImage_$reflection())], ["ImageUploading", bool_type]]);
}

const maxSenderImages = 5;

function init(toolWithQuantity, userId, successCallback, onClose) {
    let businessUnitId;
    return [new State(undefined, toolWithQuantity, new AssignToolWithQuantityWithoutNotificationDto("", undefined, "", 1, "", undefined, empty()), FormState_get_empty(), successCallback, onClose, undefined, undefined, undefined, false, false, new RequestedValue$1(0, []), new RequestedValue$1(0, []), empty(), false), Cmd_batch(ofArray([(businessUnitId = toolWithQuantity.BusinessUnitId, Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let url_2;
        return ((url_2 = addPrefix(url), (refreshOn) => fetchWithDecoder(url_2, singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
            const pr = response.arrayBuffer();
            return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), list_type(Receiver_$reflection())));
        }, refreshOn)))(true).then((_arg) => {
            const result_1 = _arg;
            return (result_1.tag === 1) ? (Promise.resolve((() => {
                throw new ValidationOnGetRequest(result_1.fields[0]);
            })())) : (Promise.resolve(result_1.fields[0]));
        });
    })), concat("/api/receivers/active", ...((businessUnitId == null) ? "?businessUnitId=" : concat("?businessUnitId=", ...businessUnitId))), (Item) => (new Msg(8, [Item])), (Item_1) => (new Msg(10, [Item_1])))), Cmd_OfPromise_either((url_3) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder_1(0, addPrefix_1(url_3), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response_1) => {
        const pr_1 = response_1.arrayBuffer();
        return pr_1.then((blob_1) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob_1)), list_type(Storage_$reflection())));
    })))), "/api/storages/access", (Item_2) => (new Msg(9, [Item_2])), (Item_3) => (new Msg(10, [Item_3])))]))];
}

function update(msg, state) {
    let bind$0040, bind$0040_1, file_1;
    switch (msg.tag) {
        case 0:
            return [new State(msg.fields[0], state.ToolWithQuantity, state.Dto, state.FormState, state.SuccessCallback, state.OnClose, state.SelectedUser, state.SelectedStorage, state.IsStockInvalid, state.WithNotification, state.WithSignature, state.Receivers, state.Storages, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
        case 5:
            return [new State(state.Quantity, state.ToolWithQuantity, state.Dto, state.FormState, state.SuccessCallback, state.OnClose, state.SelectedUser, msg.fields[0], state.IsStockInvalid, state.WithNotification, state.WithSignature, state.Receivers, state.Storages, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
        case 1:
            return [new State(state.Quantity, state.ToolWithQuantity, (bind$0040 = state.Dto, new AssignToolWithQuantityWithoutNotificationDto(bind$0040.ReceiverId, bind$0040.SenderId, bind$0040.StorageId, bind$0040.Quantity, msg.fields[0], bind$0040.SignatureUrl, bind$0040.SenderImageUrls)), state.FormState, state.SuccessCallback, state.OnClose, state.SelectedUser, state.SelectedStorage, state.IsStockInvalid, state.WithNotification, state.WithSignature, state.Receivers, state.Storages, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
        case 4:
            return [new State(state.Quantity, state.ToolWithQuantity, state.Dto, state.FormState, state.SuccessCallback, state.OnClose, msg.fields[0], state.SelectedStorage, state.IsStockInvalid, state.WithNotification, state.WithSignature, state.Receivers, state.Storages, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
        case 2: {
            const withNotification = msg.fields[0];
            if (!withNotification) {
                return [new State(state.Quantity, state.ToolWithQuantity, state.Dto, state.FormState, state.SuccessCallback, state.OnClose, state.SelectedUser, state.SelectedStorage, state.IsStockInvalid, withNotification, false, state.Receivers, state.Storages, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
            }
            else {
                return [new State(state.Quantity, state.ToolWithQuantity, state.Dto, state.FormState, state.SuccessCallback, state.OnClose, state.SelectedUser, state.SelectedStorage, state.IsStockInvalid, withNotification, state.WithSignature, state.Receivers, state.Storages, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
            }
        }
        case 3: {
            const withSignature = msg.fields[0];
            if (withSignature) {
                return [new State(state.Quantity, state.ToolWithQuantity, state.Dto, state.FormState, state.SuccessCallback, state.OnClose, state.SelectedUser, state.SelectedStorage, state.IsStockInvalid, true, withSignature, state.Receivers, state.Storages, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
            }
            else {
                return [new State(state.Quantity, state.ToolWithQuantity, state.Dto, state.FormState, state.SuccessCallback, state.OnClose, state.SelectedUser, state.SelectedStorage, state.IsStockInvalid, state.WithNotification, withSignature, state.Receivers, state.Storages, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
            }
        }
        case 6: {
            const response_1 = msg.fields[0];
            if (response_1.tag === 1) {
                return [new State(state.Quantity, state.ToolWithQuantity, state.Dto, FormState__setValidationResponse_5219762A(state.FormState, response_1.fields[0]), state.SuccessCallback, state.OnClose, state.SelectedUser, state.SelectedStorage, state.IsStockInvalid, state.WithNotification, state.WithSignature, state.Receivers, state.Storages, state.SenderImageFiles, state.ImageUploading), Cmd_errorToast("validation.toast")];
            }
            else {
                return [new State(state.Quantity, state.ToolWithQuantity, state.Dto, FormState_get_empty(), state.SuccessCallback, state.OnClose, state.SelectedUser, state.SelectedStorage, state.IsStockInvalid, state.WithNotification, state.WithSignature, state.Receivers, state.Storages, state.SenderImageFiles, state.ImageUploading), Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    state.SuccessCallback();
                }), Cmd_successToast("general.saved_successfully"), Cmd_ofEffect((_arg_1) => {
                    state.OnClose();
                })]))];
            }
        }
        case 7: {
            const matchValue = state.SelectedUser;
            const matchValue_1 = state.SelectedStorage;
            const matchValue_2 = state.Quantity;
            let matchResult, quantity, receiver, storage;
            if (matchValue == null) {
                matchResult = 1;
            }
            else if (matchValue_1 == null) {
                matchResult = 1;
            }
            else if (matchValue_2 == null) {
                matchResult = 1;
            }
            else {
                matchResult = 0;
                quantity = matchValue_2;
                receiver = matchValue;
                storage = matchValue_1;
            }
            switch (matchResult) {
                case 0: {
                    const sps_2 = find((sps) => (sps.StorageId === unwrapStorageId(storage.value.Id)), state.ToolWithQuantity.StockPerStorage).Stock | 0;
                    const senderImageUrls = choose((f) => {
                        if (f.tag === 1) {
                            return f.fields[0].ImageUrl;
                        }
                        else {
                            return undefined;
                        }
                    }, state.SenderImageFiles);
                    if (sps_2 >= quantity) {
                        const cmd = (state.WithNotification && (equals(receiver.value.ReceiverType, new ReceiverTypeName(0, [])) ? true : (receiver.value.Email != null))) ? assignWithNotificationCmd(new ToolId(parse(state.ToolWithQuantity.Id)), new AssignToolWithQuantityWithNotificationDto(receiver.value.Id, unwrapStorageId(storage.value.Id), quantity, state.Dto.Comment, state.WithSignature, "storageToUser", senderImageUrls), (Item_1) => (new Msg(6, [Item_1])), (Item_2) => (new Msg(10, [Item_2]))) : assignCmd(new ToolId(parse(state.ToolWithQuantity.Id)), (bind$0040_1 = state.Dto, new AssignToolWithQuantityWithoutNotificationDto(receiver.value.Id, bind$0040_1.SenderId, unwrapStorageId(storage.value.Id), quantity, bind$0040_1.Comment, bind$0040_1.SignatureUrl, senderImageUrls)), (Item_4) => (new Msg(6, [Item_4])), (Item_5) => (new Msg(10, [Item_5])));
                        return [new State(state.Quantity, state.ToolWithQuantity, state.Dto, FormState__startLoading(state.FormState), state.SuccessCallback, state.OnClose, state.SelectedUser, state.SelectedStorage, undefined, state.WithNotification, state.WithSignature, state.Receivers, state.Storages, state.SenderImageFiles, state.ImageUploading), cmd];
                    }
                    else {
                        return [new State(state.Quantity, state.ToolWithQuantity, state.Dto, state.FormState, state.SuccessCallback, state.OnClose, state.SelectedUser, state.SelectedStorage, sps_2, state.WithNotification, state.WithSignature, state.Receivers, state.Storages, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
                    }
                }
                default:
                    return [state, Cmd_none()];
            }
        }
        case 9:
            return [new State(state.Quantity, state.ToolWithQuantity, state.Dto, state.FormState, state.SuccessCallback, state.OnClose, state.SelectedUser, state.SelectedStorage, state.IsStockInvalid, state.WithNotification, state.WithSignature, state.Receivers, new RequestedValue$1(1, [msg.fields[0]]), state.SenderImageFiles, state.ImageUploading), Cmd_none()];
        case 10:
            return [new State(state.Quantity, state.ToolWithQuantity, state.Dto, state.FormState, state.SuccessCallback, state.OnClose, state.SelectedUser, state.SelectedStorage, state.IsStockInvalid, state.WithNotification, state.WithSignature, state.Receivers, state.Storages, state.SenderImageFiles, false), Cmd_none()];
        case 11: {
            const newFiles = msg.fields[0];
            const alreadyUploadedCount = sumBy((f_1) => {
                if (f_1.tag === 1) {
                    return 1;
                }
                else {
                    return 0;
                }
            }, state.SenderImageFiles, {
                GetZero: () => 0,
                Add: (x, y) => ((x + y) | 0),
            }) | 0;
            const pickedFile = tryPick((f_2) => {
                if (f_2.tag === 0) {
                    return f_2.fields[0].File;
                }
                else {
                    return undefined;
                }
            }, newFiles);
            let matchResult_1, file_2;
            if (pickedFile != null) {
                if ((file_1 = pickedFile, alreadyUploadedCount < maxSenderImages)) {
                    matchResult_1 = 0;
                    file_2 = pickedFile;
                }
                else {
                    matchResult_1 = 1;
                }
            }
            else {
                matchResult_1 = 1;
            }
            switch (matchResult_1) {
                case 0: {
                    const formData = new FormData();
                    formData.append(file_2.name, file_2);
                    return [new State(state.Quantity, state.ToolWithQuantity, state.Dto, state.FormState, state.SuccessCallback, state.OnClose, state.SelectedUser, state.SelectedStorage, state.IsStockInvalid, state.WithNotification, state.WithSignature, state.Receivers, state.Storages, newFiles, true), uploadImage((Item_6) => (new Msg(12, [Item_6])), (Item_7) => (new Msg(10, [Item_7])), formData)];
                }
                default:
                    return [new State(state.Quantity, state.ToolWithQuantity, state.Dto, state.FormState, state.SuccessCallback, state.OnClose, state.SelectedUser, state.SelectedStorage, state.IsStockInvalid, state.WithNotification, state.WithSignature, state.Receivers, state.Storages, newFiles, state.ImageUploading), Cmd_none()];
            }
        }
        case 12: {
            const response_3 = msg.fields[0];
            switch (response_3.tag) {
                case 0:
                    return [new State(state.Quantity, state.ToolWithQuantity, state.Dto, state.FormState, state.SuccessCallback, state.OnClose, state.SelectedUser, state.SelectedStorage, state.IsStockInvalid, state.WithNotification, state.WithSignature, state.Receivers, state.Storages, filter((f_5) => {
                        if (f_5.tag === 1) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }, state.SenderImageFiles), false), Cmd_errorToast("general.file_too_large")];
                case 2:
                    return [new State(state.Quantity, state.ToolWithQuantity, state.Dto, state.FormState, state.SuccessCallback, state.OnClose, state.SelectedUser, state.SelectedStorage, state.IsStockInvalid, state.WithNotification, state.WithSignature, state.Receivers, state.Storages, filter((f_6) => {
                        if (f_6.tag === 1) {
                            return true;
                        }
                        else {
                            return false;
                        }
                    }, state.SenderImageFiles), false), Cmd_errorToast("general.a_error_occured")];
                default: {
                    const nextPosition = (1 + max(append(singleton(0), choose((f_3) => {
                        if (f_3.tag === 1) {
                            return f_3.fields[0].Position;
                        }
                        else {
                            return undefined;
                        }
                    }, state.SenderImageFiles)), {
                        Compare: (x_1, y_1) => (comparePrimitives(x_1, y_1) | 0),
                    })) | 0;
                    return [new State(state.Quantity, state.ToolWithQuantity, state.Dto, state.FormState, state.SuccessCallback, state.OnClose, state.SelectedUser, state.SelectedStorage, state.IsStockInvalid, state.WithNotification, state.WithSignature, state.Receivers, state.Storages, append(choose((f_4) => {
                        if (f_4.tag === 1) {
                            return f_4;
                        }
                        else {
                            return undefined;
                        }
                    }, state.SenderImageFiles), singleton(new DnDFormImage(1, [{
                        ImageUrl: response_3.fields[0].ImageUrl,
                        Position: nextPosition,
                    }]))), false), Cmd_none()];
                }
            }
        }
        default:
            return [new State(state.Quantity, state.ToolWithQuantity, state.Dto, state.FormState, state.SuccessCallback, state.OnClose, state.SelectedUser, state.SelectedStorage, state.IsStockInvalid, state.WithNotification, state.WithSignature, new RequestedValue$1(1, [msg.fields[0]]), state.Storages, state.SenderImageFiles, state.ImageUploading), Cmd_none()];
    }
}

function targetStorages(user, props) {
    return filter((s_1) => {
        const matchValue = user.Role;
        switch (matchValue) {
            case "toolManager":
            case "user":
                return contains(user.Id, s_1.AssignedUserIds, {
                    Equals: (x_1, y_1) => (x_1 === y_1),
                    GetHashCode: (x_1) => (stringHash(x_1) | 0),
                });
            default:
                return true;
        }
    }, filter((s) => {
        const source = map((sps) => sps.StorageId, props.Tool.StockPerStorage);
        return contains(unwrapStorageId(s.Id), source, {
            Equals: (x, y) => (x === y),
            GetHashCode: (x) => (stringHash(x) | 0),
        });
    }, props.Storages));
}

function DialogBody(props) {
    let arg_1, stock_1, quantity, elems, elems_4;
    const patternInput = useTranslation();
    const t = patternInput[0];
    const data = useFeliz_React__React_useDeferred_Static_Z241A641(Async_fetchWithDecoder(0, addPrefix_1(concat("/api/receivers/users/", unwrapUserId(new UserId_1(props.UserId)), ..."/details")), "", new HttpMethod(0, []), "application/json", (response) => singleton_1.Delay(() => {
        let resp;
        const matchValue = response.content;
        switch (matchValue.tag) {
            case 0: {
                throw new Exception("not implemented - text response");
                break;
            }
            case 1: {
                throw new Exception("not implemented - blob response");
                break;
            }
            case 3: {
                resp = matchValue.fields[0];
                break;
            }
            default:
                resp = (new Uint8Array(matchValue.fields[0]));
        }
        return singleton_1.Return(Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(resp), Requests_UserDto_$reflection()));
    })), []);
    switch (data.tag) {
        case 1:
        case 0:
            return spinner;
        case 2: {
            const targetStorages_1 = targetStorages(data.fields[0], {
                Storages: props.Storages,
                Tool: props.Tool,
                UserId: props.UserId,
            });
            const storageOptions = map((storage) => ({
                label: storage.Name,
                value: storage,
            }), targetStorages_1);
            let reservationAlert_1;
            const matchValue_1 = props.SelectedStorage;
            if (matchValue_1 == null) {
                reservationAlert_1 = undefined;
            }
            else {
                const storage_1 = matchValue_1;
                const stock = map_1((stockPerStorage_1) => (stockPerStorage_1.Stock | 0), tryFind((stockPerStorage) => (stockPerStorage.StorageId === unwrapStorageId(storage_1.value.Id)), props.Tool.StockPerStorage));
                const reservedStock = sum(map((reservation_1) => (reservation_1.Quantity | 0), filter((reservation) => doRangesOverlap(today(), addDays(today(), 7), reservation.StartDate, reservation.EndDate), props.Tool.Reservations)), {
                    GetZero: () => 0,
                    Add: (x_1, y) => ((x_1 + y) | 0),
                }) | 0;
                const matchValue_2 = props.Quantity;
                let matchResult, quantity_1, stock_2;
                if (stock == null) {
                    if (matchValue_2 == null) {
                        matchResult = 1;
                    }
                    else {
                        matchResult = 1;
                    }
                }
                else if (matchValue_2 == null) {
                    matchResult = 1;
                }
                else if ((stock_1 = (stock | 0), (quantity = (matchValue_2 | 0), reservedStock !== 0))) {
                    matchResult = 0;
                    quantity_1 = matchValue_2;
                    stock_2 = stock;
                }
                else {
                    matchResult = 1;
                }
                switch (matchResult) {
                    case 0: {
                        reservationAlert_1 = ((((stock_2 - reservedStock) - quantity_1) < 0) ? createElement(WarningAlert, {
                            Label: (arg_1 = {
                                dateString: "reminder.Date.ToString(\"dd.MM.yyyy\")",
                                reminderName: "reminder.Title",
                            }, patternInput[1].t("tool.reservation_dialog.reservation_stock_to_low_warning", arg_1)),
                        }) : undefined);
                        break;
                    }
                    default:
                        reservationAlert_1 = undefined;
                }
            }
            if (isEmpty(targetStorages_1)) {
                return reactElement("div", createObj(singleton((elems = [reactElement("strong", {
                    children: t("tool.not_responsible_storage_msg"),
                }), reactElement("p", {
                    children: t("tool.not_responsible_storage_info_msg"),
                })], ["children", reactApi.Children.toArray(Array.from(elems))]))));
            }
            else {
                return reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-4"])], (elems_4 = toList(delay(() => {
                    let matchValue_4, reservationAlert_2;
                    return append_1((matchValue_4 = reservationAlert_1, (matchValue_4 == null) ? (empty_1()) : ((reservationAlert_2 = matchValue_4, singleton_2(reactElement("div", {
                        className: join(" ", ["max-w-[40rem]"]),
                        children: reactApi.Children.toArray([reservationAlert_2]),
                    }))))), delay(() => append_1(singleton_2(createElement(Select, {
                        ComponentState: props.ComponentState,
                        IsClearable: false,
                        Label: t("tool.choose_storage"),
                        NoOptionsMessage: "select.storage_no_options",
                        OnChange: (arg_2) => {
                            props.Dispatch(new Msg(5, [arg_2]));
                        },
                        Options: storageOptions,
                        PlaceholderKey: "select.storage_placeholder",
                        TestId: "choose-storage-select-test-id",
                        Value: unwrap(props.SelectedStorage),
                    })), delay(() => append_1(singleton_2(createElement(GroupedSelect, (($value) => { $value.key = $value.Key; return $value; })({
                        ComponentState: "enabled",
                        IsClearable: false,
                        Key: "select-user",
                        Label: t("tool.choose_receiver"),
                        NoOptionsMessage: "select.employee_no_options",
                        OnChange: (arg_3) => {
                            props.Dispatch(new Msg(4, [arg_3]));
                        },
                        Options: map((tupledArg) => {
                            const receiverType = tupledArg[0];
                            const receivers_1 = toArray(sortBy((receiver_2) => receiver_2.label.toLowerCase(), map((receiver_1) => {
                                const matchValue_6 = receiver_1.LocationName;
                                if (matchValue_6 != null) {
                                    const locationName = matchValue_6;
                                    if (equals(receiverType, new ReceiverTypeName(4, []))) {
                                        return {
                                            label: concat(locationName, " - ", ...receiver_1.Name),
                                            value: receiver_1,
                                        };
                                    }
                                    else {
                                        return {
                                            label: concat(receiver_1.Name, " - ", ...locationName),
                                            value: receiver_1,
                                        };
                                    }
                                }
                                else {
                                    return {
                                        label: receiver_1.Name,
                                        value: receiver_1,
                                    };
                                }
                            }, tupledArg[1]), {
                                Compare: (x_3, y_2) => (comparePrimitives(x_3, y_2) | 0),
                            }));
                            return {
                                label: Helper_receiverTypeNameTranslation(t, receiverType),
                                options: receivers_1,
                            };
                        }, List_groupBy((receiver) => receiver.ReceiverType, filter((u) => {
                            if (props.WithNotification) {
                                const matchValue_5 = u.ReceiverType;
                                switch (matchValue_5.tag) {
                                    case 10:
                                        return false;
                                    case 1:
                                    case 5:
                                    case 8:
                                    case 6:
                                    case 2:
                                    case 7:
                                    case 3:
                                    case 9:
                                    case 4:
                                        return u.Email != null;
                                    default:
                                        return true;
                                }
                            }
                            else {
                                return true;
                            }
                        }, props.Users), {
                            Equals: equals,
                            GetHashCode: (x_2) => (safeHash(x_2) | 0),
                        })),
                        PlaceholderKey: "select.employee_placeholder",
                        Value: unwrap(props.SelectedReceiver),
                    }))), delay(() => append_1(singleton_2(createElement(TextArea, {
                        ComponentState: props.ComponentState,
                        Label: t("general.comment"),
                        OnChange: (arg_4) => {
                            props.Dispatch(new Msg(1, [arg_4]));
                        },
                        TestId: "toolwithquantity-assign-comment-test-id",
                        Value: props.Comment,
                    })), delay(() => {
                        let Label_3, Value_4;
                        return append_1(singleton_2(createElement(NumberInput, (Label_3 = t("general.quantity_3"), (Value_4 = map_1((value_9) => value_9, props.Quantity), {
                            ComponentState: props.ComponentState,
                            Label: unwrap(Label_3),
                            MaxValue: numberInputIntMaxValue,
                            OnChange: (arg_6) => {
                                props.Dispatch(new Msg(0, [map_1((value_10) => (~~value_10 | 0), arg_6)]));
                            },
                            TestId: "quantity-input-test-id",
                            ValidationMessage: unwrap(FormState__getValidation(props.FormState, t, "quantity")),
                            Value: unwrap(Value_4),
                        })))), delay(() => {
                            let Label_4, matchValue_7, selectedUser;
                            return append_1(singleton_2(Checkbox((Label_4 = t("tool.dialog_assign_with_notification"), {
                                ComponentState: (matchValue_7 = props.SelectedReceiver, (matchValue_7 != null) ? ((selectedUser = matchValue_7, (props.ComponentState === "enabled") ? ((equals(selectedUser.value.ReceiverType, new ReceiverTypeName(0, [])) ? true : (selectedUser.value.Email != null)) ? "enabled" : "disabled") : props.ComponentState)) : props.ComponentState),
                                IsChecked: props.WithNotification,
                                Label: Label_4,
                                OnCheck: (arg_7) => {
                                    props.Dispatch(new Msg(2, [arg_7]));
                                },
                                TestId: "assign-tool-dialog-with-notification-test-id",
                            }))), delay(() => {
                                let elems_2;
                                return append_1(singleton_2(reactElement("div", createObj(ofArray([["className", join(" ", [])], (elems_2 = [createElement(InformationAlert, {
                                    Label: t("tool.dialog_assign_with_notification_info"),
                                })], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
                                    let Label_5, matchValue_9, selectedUser_1;
                                    return append_1(singleton_2(Checkbox((Label_5 = t("tool.dialog_assign_with_signature"), {
                                        ComponentState: (matchValue_9 = props.SelectedReceiver, (matchValue_9 != null) ? ((selectedUser_1 = matchValue_9, (props.ComponentState === "enabled") ? ((equals(selectedUser_1.value.ReceiverType, new ReceiverTypeName(0, [])) ? true : (selectedUser_1.value.Email != null)) ? "enabled" : "disabled") : props.ComponentState)) : props.ComponentState),
                                        IsChecked: props.WithSignature,
                                        Label: Label_5,
                                        OnCheck: (arg_8) => {
                                            props.Dispatch(new Msg(3, [arg_8]));
                                        },
                                        TestId: "assign-tool-dialog-with-notification-test-id",
                                    }))), delay(() => {
                                        let elems_3;
                                        return append_1(singleton_2(reactElement("div", createObj(ofArray([["className", join(" ", ["grid", "gap-2"])], (elems_3 = [createElement(TextValue, {
                                            FontWeight: "bold",
                                            TestId: "",
                                            Text: t("assignment_notification.sender_images"),
                                        }), createElement(ImageUpload, {
                                            ComponentState: props.ImageUploading ? "disabled" : props.ComponentState,
                                            SelectedFiles: props.SenderImageFiles,
                                            SetSelectedFile: (files) => {
                                                props.Dispatch(new Msg(11, [files]));
                                            },
                                        })], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => {
                                            const matchValue_11 = FormState__getValidation(props.FormState, t, "global");
                                            if (matchValue_11 == null) {
                                                return empty_1();
                                            }
                                            else {
                                                return singleton_2(createElement(ErrorAlert, {
                                                    Label: matchValue_11,
                                                }));
                                            }
                                        }));
                                    }));
                                }));
                            }));
                        }));
                    }))))))));
                })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])));
            }
        }
        default:
            return concat("error ", ...data.fields[0].message);
    }
}

export function AssignToolWithQuantityDialog(props) {
    let Title;
    const t = useTranslation()[0];
    const patternInput_1 = React_useElmish_Z6C327F2E(() => ProgramModule_mkProgram(() => init(props.Tool, props.UserId, props.SuccessCallback, props.OnClose), update, (_arg_1, _arg_1_1) => {
    }), undefined, [props.IsOpen]);
    const state_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const componentState = state_1.FormState.IsLoading ? "disabled" : "enabled";
    return createElement(Dialog, (Title = t("tool.deal_out_tool"), {
        Body: toList(delay(() => {
            const matchValue = state_1.Receivers;
            const matchValue_1 = state_1.Storages;
            let matchResult, receivers, storages;
            if (matchValue.tag === 0) {
                if (matchValue_1.tag === 0) {
                    matchResult = 1;
                }
                else {
                    matchResult = 1;
                }
            }
            else if (matchValue_1.tag === 0) {
                matchResult = 1;
            }
            else {
                matchResult = 0;
                receivers = matchValue.fields[0];
                storages = matchValue_1.fields[0];
            }
            switch (matchResult) {
                case 0:
                    return singleton_2(createElement(DialogBody, {
                        Comment: state_1.Dto.Comment,
                        ComponentState: componentState,
                        Dispatch: dispatch,
                        FormState: state_1.FormState,
                        ImageUploading: state_1.ImageUploading,
                        IsStockInvalid: unwrap(state_1.IsStockInvalid),
                        Quantity: unwrap(state_1.Quantity),
                        SelectedReceiver: unwrap(state_1.SelectedUser),
                        SelectedStorage: unwrap(state_1.SelectedStorage),
                        SenderImageFiles: state_1.SenderImageFiles,
                        Storages: storages,
                        Tool: props.Tool,
                        UserId: props.UserId,
                        Users: receivers,
                        WithNotification: state_1.WithNotification,
                        WithSignature: state_1.WithSignature,
                    }));
                default:
                    return singleton_2(createElement(Skeleton, {
                        Variant: "normal",
                    }));
            }
        })),
        Controls: ofArray([createElement(TextButton, {
            ComponentState: "enabled",
            Label: t("general.cancel"),
            OnClick: props.OnClose,
            TestId: "close-assign-twq-dialog-test-id",
            Variant: "blueButton",
        }), createElement(TextButton, {
            ComponentState: state_1.ImageUploading ? "disabled" : componentState,
            Label: t("general.save"),
            OnClick: () => {
                dispatch(new Msg(7, []));
            },
            TestId: "save-assign-twq-dialog-test-id",
            Variant: "blueButton",
        })]),
        IsOpen: props.IsOpen,
        OnClose: props.OnClose,
        Title: Title,
    }));
}

